// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__24KJS","sendOtp":"AuthorizeToLogin_sendOtp__r66Pt"};